import { api } from './auth.service';

const colaboradorHorarioService = {
  listar: async () => {
    const r = await api.get('/colaboradores-horario');
    return r.data;
  },

  // Salva override pra um colaborador (campos null → usa global)
  upsert: async (colaboradorId, dados) => {
    const r = await api.put(`/colaboradores-horario/${colaboradorId}`, dados);
    return r.data;
  },

  // Remove override (volta a usar global)
  remover: async (colaboradorId) => {
    const r = await api.delete(`/colaboradores-horario/${colaboradorId}`);
    return r.data;
  },
};

export default colaboradorHorarioService;
